<template>
    <div class="board">
        <div class="sub-board-client">
            <ClientCard :customer="customer" :benefitTypes="benefitTypes" :customerEnrollments="customerEnrollments" :dropClient="dropClient" :editClient="editClient" />
            <BrandCard :customer="customer" />
            <EnrollmentsCard :jobs="jobs" :loading="loadingJobs" :customerEnrollments="customerEnrollments" :selectEnrollment="selectEnrollment" :selectedEnrollment="selectedEnrollment" :benefitTypes="benefitTypes" />
        </div>
        <div class="sub-board-products">
            <div class="sub-board-actions">
                <button class="btn-refresh" :disabled="refreshLoading" v-on:click="refreshCustomer(customer.id)">
                    <p>Atualizar</p>
                    <v-progress-circular
                        :size="14"
                        :width="3"
                        color="#0d0b53"
                        indeterminate
                        v-if="refreshLoading"
                    ></v-progress-circular>
                </button>
                <button class="btn-new" v-on:click="openNewContract()">
                    <v-icon>fas fa-plus</v-icon>
                    <p>Nova Oportunidade</p>
                </button>
            </div>
            <LeadsCard v-if="leads && leads.length" :leads="leads" :offerLeadStatus="offerLeadStatus" :tags="tags" />
            <div class="sub-board-products-cards">
                <OpportunitiesCard :loading="loadingJobs" :selectedJob="selectedJob" :customerId="customer.id" />
                <ContractsCard :loading="loadingJobs" :selectedJob="selectedJob" />
            </div>
        </div>
    </div>
</template>

<script>
import ClientCard from './Cards/ClientCard.vue';
import OpportunitiesCard from './Cards/OpportunitiesCard.vue';
import ContractsCard from './Cards/ContractsCard.vue';
import EnrollmentsCard from './Cards/EnrollmentsCard.vue';
import LeadsCard from './Cards/LeadsCard.vue';
import BrandCard from './Cards/BrandCard.vue';

export default {
    components: { ClientCard, OpportunitiesCard, ContractsCard, EnrollmentsCard, LeadsCard, BrandCard },

    data() {
        return {
            jobs: [],
            loadingJobs: false,
            selectedEnrollment: null,

            leads: [],
            loadingLeads: false,

            refreshLoading: false,
        }
    },

    props: {
        customer: {
            type: Object,
            required: true
        },
        benefitTypes: {
            type: Array,
            required: true
        },
        refresh: {
            type: Function,
            required: true
        },
        dropClient: {
            type: Function,
            required: true
        },
        editClient: {
            type: Function,
            required: true
        },
        offerLeadStatus: {
            type: Array,
            required: true
        },
        tags: {
            type: Array,
            required: true
        }
    },

    computed: {
        customerEnrollments() {
			if (this.jobs.length) {
				return this.jobs.map(job => job.enrollment.replace(/[^\w\s]/gi, ''));
			}

			return [];
		},

        selectedJob() {
			if (this.jobs && this.jobs.length && this.selectedEnrollment) {
				return this.jobs.find(job => job.enrollment == this.selectedEnrollment);
			}

			return {};
		},
    },

    methods: {
        selectEnrollment(enrollment) {
            this.selectedEnrollment = enrollment;
        },

        async getJobs(customerId) {
            this.loadingJobs = true;

            try {
                this.jobs = await this.$api.dataService.execute('prospection/getCustomerJobs', {
                    customerId
                });
            } catch(e) {
                // TODO: handle error
            }

            this.loadingJobs = false;
        },

        async getLeads(customerId) {
            this.loadingLeads = true;

            try {
                this.leads = await this.$api.dataService.execute('prospection/getCustomerLeads', {
                    customerId
                });
            } catch(e) {
                // TODO: handle error
            }

            this.loadingLeads = false;
        },

        async refreshCustomer(customerId) {
            this.refreshLoading = true;

            try {
                await Promise.all([
                    this.getJobs(customerId),
                    this.getLeads(customerId),
                ]);
            } catch(e) {
                // TODO: handle error
            }

            this.refreshLoading = false;
        },

        openNewContract() {
			window.getApp.showModal('Propostas', {
				doneCallback: () => { this.refreshCustomer(this.customer.id); },
				props: {
					obj: 'contract',
					kind: 'OPT',
					customerId: this.customer.id,
					statusId: 0
				},
				modalWidth: 600,
			});
		},
    },

    watch: {
        async 'customer.id'(customerId) {
            await this.getJobs(customerId);
            await this.getLeads(customerId);

            if (this.jobs.length) {
                this.selectedEnrollment = this.jobs[0].enrollment;
            }
        }
    },

    async created() {
        await this.getJobs(this.customer.id);
        await this.getLeads(this.customer.id);
    }
}
</script>

<style scoped>
    p {
        margin: 0;
    }

    .board {
        height: 100%;
        width: 100%;
        display: flex;
        padding: 50px;
        align-items: flex-start;
        gap: 20px;
        overflow: auto;
    }

    .sub-board-client {
        display: flex;
        flex-direction: column;
        gap: 20px;
        flex: 2;
    }

    .sub-board-products {
        display: flex;
        flex-direction: column;
        gap: 20px;
        flex: 5;
    }

    .sub-board-products-cards {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 20px;
    }

    .sub-board-actions {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 20px;
    }

    .btn-new {
        padding: 10px;
        border-radius: 5px;
        background-color: var(--success-color);
        color: white;
        transition: .2s;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    .btn-new > i {
        font-size: 16px;
        color: white;
    }

    .btn-new:hover {
        background-color: var(--secondary-color-hover);
    }

    .btn-refresh {
        color: var(--primary-color);
        background-color: white;
        padding: 10px 20px;
        font-weight: bold;
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }

</style>


// WEBPACK FOOTER //
// src/components/Prospection/ClientBoard.vue